import * as Clipboard from 'expo-clipboard';
import { Platform, Share } from 'react-native';

import { showToast } from '@/lib/useToastStore';

type ShareLinkResult = 'shared' | 'copied' | 'failed';

type ShareLinkInput = {
  fallbackMessage?: string;
  message: string;
  onCopyFallback?: () => void | Promise<void>;
  title?: string;
  url?: string;
};

export async function shareLink({
  fallbackMessage = 'Link copied. Share it anywhere.',
  message,
  onCopyFallback,
  title,
  url,
}: ShareLinkInput): Promise<ShareLinkResult> {
  try {
    await Share.share(
      Platform.OS === 'web'
        ? { message, title, url }
        : { message: url && !message.includes(url) ? `${message}\n${url}` : message, title }
    );
    return 'shared';
  } catch {
    const fallbackValue = url || message;
    if (!fallbackValue) {
      return 'failed';
    }

    try {
      await Clipboard.setStringAsync(fallbackValue);
      await onCopyFallback?.();
      showToast({ message: fallbackMessage });
      return 'copied';
    } catch {
      return 'failed';
    }
  }
}
